import { adminApi, ipRegistry, ipStackClient, cardsActivityadminApi, devlopConfigAPi, gatewaysApi, loginApi, identityApi, cardsServiceApi } from ".";
import { ApiControllers } from "./config";
import CryptoJS from "crypto-js";
const convertUTCToLocalTime = (dateString) => {
  let date = new Date(dateString);
  const milliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );
  const localTime = new Date(milliseconds);
  return localTime.toISOString();
};
const isErrorDispaly = (objValue) => {
  if ((objValue?.status >= 400 && objValue?.status <= 500) && objValue?.status != 401) {
    return "Something went wrong please try again!";
  } else {
    if (objValue?.data && typeof objValue?.data === "string") {
      return objValue?.data;
    } else if (objValue?.data && objValue?.data?.title && typeof objValue?.data?.title) {
      return objValue?.data?.title;
    } else if (
      objValue?.originalError &&
      typeof objValue?.originalError?.message === "string"
    ) {
      return objValue?.originalError?.message;
    } else {
      return typeof (objValue) === "object" && objValue?.reason ? objValue?.reason : "Something went wrong please try again!";
    }
  }
};
const uploadErrorDisplay = (objValue) => {
  if ((objValue?.status >= 400 && objValue?.status < 500) && objValue?.status != 401) {
    return "Something went wrong please try again!";
  } else if (objValue?.title && typeof objValue?.title) {
    return objValue?.title;
  } else {
    return "Something went wrong please try again!";
  }
}
const fetchAdminDetails = () => {
  return gatewaysApi.get(`abp/application-configuration?includeLocalizationResources=false`)
}
const encryptValue = (msg, key) => {
  msg = typeof msg == "object" ? JSON.stringify(msg) : msg;
  let salt = CryptoJS.lib.WordArray.random(128 / 8);
  let key1 = CryptoJS.PBKDF2(key, salt, {
    keySize: 256 / 32,
    iterations: 10,
  });
  let iv = CryptoJS.lib.WordArray.random(128 / 8);
  let encrypted = CryptoJS.AES.encrypt(msg, key1, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return salt.toString() + iv.toString() + encrypted.toString();
};
const getIpRegistery = () => {
  return ipRegistry.get("/?key=" + process.env.REACT_APP_IPREGISTERY_KEY);
};
const getIpStack = () => {
  return ipStackClient.get('check?access_key=' + process.env.REACT_APP_IPSTACK_KEY)
}
const getLookups = (url => {
  return adminApi.get(url);
})
const getCardsLookups = (url => {
  return cardsActivityadminApi.get(ApiControllers.CardsActivityService + url);
})
const getcardNames = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `CardNamesLookUp`)
}
const cardDetails = (url, id) => {
  return adminApi.get(ApiControllers.cardsManageservice + `${url}/${id}`)
}
const getCardDetails = (url, id, tenanatId) => {
  return adminApi.get(ApiControllers.cardsManageservice + `${url}/${id}/${tenanatId}`)
}
const getCurrenciesLu = () => {
  return adminApi.get(`/CardsActivityService/CurrencyLu`)
}
const getTokenKey = () => {
  return adminApi.post(ApiControllers.cardsManageservice + `GenerateTokenKey`)
}
const savedevConfig = (obj) => {
  return devlopConfigAPi.put(ApiControllers.cardsManageservice + `WebHookSave`, obj)
}
const savedevKey = (obj) => {
  return devlopConfigAPi.post(ApiControllers.cardsManageservice + `Keys`, obj)
}
const getToken = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `Tokens`)
}
const getwebHookUrl = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `WebHookUrl`)
}
const getDevKey = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `GetKeys`)
}
const gettotalAssets = () => {
  return adminApi.get(ApiControllers.CardsActivityService + `PortfolioBalances`)
}
const getStatusLu = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `StatusLu`)
}
const walletAddress = (walletId) => {
  return adminApi.get(ApiControllers.CardsActivityService + `Wallet/${walletId}`)
}
const getDashboardCalls = (url) => {
  return adminApi.get(ApiControllers.CardsActivityService + `${url}`)
}
const addRole = (obj) => {
  return gatewaysApi.post(`/identity/roles`, obj)
}
const kycDetails = () => {
  return adminApi.get(`KycService/GetKybDetails`)
}
const editRole = (id, obj) => {
  return gatewaysApi.put(`/identity/roles/${id}`, obj)
}
const getRoleData = (id) => {
  return gatewaysApi.get(`/identity/roles/${id}`)
}
const deleteRoleSave = (id) => {
  return gatewaysApi.delete(`/identity/roles/${id}`)
}
//-------------------Users Calls Start---------------------
const saveUserDatials = (obj) => {
  return identityApi.post(`/Custom/CreateWithPassword`, obj)
}
const editUserDatials = (id, obj) => {
  return gatewaysApi.put(`/identity/users/${id}`, obj)
}
const rolesListData = () => {
  return gatewaysApi.get(`/identity/users/assignable-roles`)
}
const getUserData = (id) => {
  return gatewaysApi.get(`/identity/users/${id}`)
}
const getPhoneCodesLookupLu = () => {
  return adminApi.get(`/KycService/CountryCode`)
}
//------------------Users Calls End---------------------------
const changePassword = (obj) => {
  return loginApi.post(`account/my-profile/change-password`, obj)
}
const getProfileImage = (id) => {
  return loginApi.get(`account/profile-picture/${id}`)
}
const uploadProfile = (obj) => {
  return loginApi.post(`account/profile-picture`, obj)
}
const personalInfo = () => {
  return loginApi.get(`account/my-profile`)
}
const editPersonalInfo = (obj) => {
  return loginApi.put(`account/my-profile`, obj)
}
const authenticatorData = () => {
  return loginApi.get(`account/authenticator-info`)
}
const setTwoFaEnable = (flag) => {
  return loginApi.post(`account/my-profile/set-two-factor-enabled?enabled=${flag}`)
}
const verifyTwoFa = (obj) => {
  return loginApi.post(`account/verify-authenticator-code`, obj)
}
const getHasAuthenticator = () => {
  return loginApi.get(`account/has-authenticator-key`)
}
const resetAuthenticator = () => {
  return loginApi.post(`account/reset-authenticator`)
}
const getCards = (customerId, type) => {
  return adminApi.get(ApiControllers.kycService + `CustomerCards/${customerId}/${type}`)
}
const cardViewDetails = (customerId, cardId) => {
  return adminApi.get(ApiControllers.kycService + `CardDetails/${customerId}/Card/${cardId}`)
}
const getcardTypeLuData = () => {
  return adminApi.get(ApiControllers.kycService + `CardType`)
}
//-----------------------------Customers Call Start--------------------
const getCustomerView = (id) => {
  return adminApi.get(`KycService/ProfileView/${id}`)
}
const getCustomerNamesLookups = (emails, name) => {
  return adminApi.get(`KycService/Customers/${emails}/${name}`)
}
const getCustomerStateLookups = (url => {
  return adminApi.get(url);
})
const getTransSourceData = (url => {
  return adminApi.get(url);
})
//-----------------------------Customers Call End--------------------
const getKYCinfo = (tenantId, userId) => {
  return adminApi.get(ApiControllers.kycService + `GetKycStatus/${tenantId}`)
}
const sumsubacesstoken = (userid, flow) => {
  return adminApi.get(ApiControllers.kycService + `AccessToken1?applicantId=${userid}&levelName=${flow}`);
};
const updateKyc = (userid) => {
  return adminApi.get(ApiControllers.kycService + `${userid}/KYC`);
};
const freezeunfreezeCard = (customerId, cardId, obj) => {
  return devlopConfigAPi.put(ApiControllers.kycService + `CardFreezeUnFreeze/${customerId}/Card/${cardId}`, obj);
}
const getTransTypelookupData = (url => {
  return adminApi.get(url);
})
const getCustomerKycInfo = (url => {
  return adminApi.get(url);
})
const rolesPerissionGet = (roleName) => {
  return gatewaysApi.get(`/permission-management/permissions?providerName=R&providerKey=${roleName}`)
}
const rolesPerissionSave = (roleName, obj) => {
  return gatewaysApi.put(`/permission-management/permissions?providerName=R&providerKey=${roleName}`, obj)
}
//Cases Start
const featchCaseDetails = (id) => {
  return adminApi.get(ApiControllers.caseManagement + `Admin/Case/${id}`)
}
const featchCaseSatateLu = (screenName, state) => {
  return adminApi.get(ApiControllers.common + `statechange/${screenName}/${state}`)
}
const assignedAdmins = () => {
  return devlopConfigAPi.get(`CaseManagement/AdminUsers`)
}
const casesTemplate = () => {
  return adminApi.get(`CaseManagement/TemplateLu`)
}
const deleteCaseAssigners = (id) => {
  return adminApi.delete(`CaseManagement/CaseAssigners/${id}`);
}
const saveTemplate = (obj) => {
  return devlopConfigAPi.post(`CaseManagement/SaveCaseTemplate`, obj);
}
const deleteCaseTemplate = (id) => {
  return adminApi.delete(`CaseManagement/DeleteTemplate/${id}`)
}
const getCasesTemplate = (id) => {
  return adminApi.get(`CaseManagement/CasesTemplate/${id}`)
}
const getCasesview = (id) => {
  return adminApi.get(`CaseManagement/Admin/Case/${id}`)
}
const getStateChangeLu = (state) => {
  return devlopConfigAPi.get(`CaseManagement/statechange/Cases/${state}`)
}
const updateStateChange = (obj) => {
  return devlopConfigAPi.put(`CaseManagement/Cases/Status`, obj)
}
const getDocumentReplies = (id) => {
  return adminApi.get(`CaseManagement/Accounts/${id}/Messages`);
}
const casesModules = () => {
  return adminApi.get(`CaseManagement/CaseModulesLookUp`);
}
const programsData = (programName, currency, state) => {
  return adminApi.get(ApiControllers.cardsManageservice + `AvailableCards/${programName}/${currency}/${state}`);
}
const getGridMetaData = (screenName, userId) => {
  return adminApi.get(ApiControllers.common + `GridMetaData/${screenName}/${userId}`)
}
const gridSaveLayout = (obj) => {
  return devlopConfigAPi.post(ApiControllers.common + `SaveLayout`, obj)
}
const gridResetLayout = (screenName, userId) => {
  return adminApi.delete(ApiControllers.common + `ResetLayOut/${screenName}/${userId}`)
}
const getCardBalances = (currency) => {
  return adminApi.get(ApiControllers.caseManagement + `Balances/CardsBalance/${currency}`);
}
const getMerchantBalances = () => {
  return adminApi.get(ApiControllers.caseManagement + `Balances/MerchantBalance`);
}

const getPrograms = () => {
  return adminApi.get(ApiControllers.caseManagement + `GetPrograms`)
}
//-------------------------Energy-------------------------
const getAvailableCredits = () => {
  return cardsServiceApi.get(ApiControllers.energy + `availablecredits`)
}
const getCreditsAmount = (value) => {
  return cardsServiceApi.get(ApiControllers.energy + `amount/${value}`)
}
const getAddress = () => {
  return cardsServiceApi.get(ApiControllers.energy + `address`)
}
const depositSave = (obj) => {
  return cardsServiceApi.post(ApiControllers.energy + `credits`, obj)
}
const getUsedCredits = (days) => {
  return cardsServiceApi.get(ApiControllers.energy + `usedCredits/${days}`)
}
const getAddressTypes = () => {
  return cardsServiceApi.get(`energy/addressLu`);
}
const saveRechargeEnergy = (obj) => {
  return cardsServiceApi.post(`Recharge`, obj)
}
const getTopupAddressLu = () => {
  return cardsServiceApi.get(`energy/topupAddress`);
}
const getTransactionsAddressLu = () => {
  return cardsServiceApi.get(`energy/transactionsAddress`);
}
//-------------------------Energy-------------------------
const getLogoUrl = () => {
  return adminApi.get(ApiControllers.cardsManageservice + `GetLogoURL`);
}
const paginatedApiUrl = (apiUrl,pageSize,pageNumber) => {
  return gatewaysApi.get(`${apiUrl}?skipCount=${pageNumber}&maxResultCount=${pageSize}`);
}

const apiCalls = {
  isErrorDispaly, fetchAdminDetails, encryptValue, getIpRegistery, uploadErrorDisplay,
  convertUTCToLocalTime, getIpStack,
  getCurrenciesLu, getToken, getwebHookUrl, getDevKey, gettotalAssets,
  cardDetails, getcardNames, getLookups, getCardsLookups, getTokenKey, savedevConfig, savedevKey,
  getCardDetails, getStatusLu, walletAddress, getDashboardCalls,
  addRole, editRole, getRoleData, saveUserDatials, editUserDatials, rolesListData, getUserData,
  changePassword, getProfileImage, uploadProfile, personalInfo, editPersonalInfo,
  authenticatorData, setTwoFaEnable, verifyTwoFa, getHasAuthenticator, resetAuthenticator, getPhoneCodesLookupLu, getCustomerView, getCustomerNamesLookups, getCustomerStateLookups,
  getCards, getcardTypeLuData, cardViewDetails, getKYCinfo, updateKyc, sumsubacesstoken, getTransSourceData, kycDetails, freezeunfreezeCard, getTransTypelookupData, getCustomerKycInfo,
  rolesPerissionGet, rolesPerissionSave, deleteRoleSave, getCasesview,
  featchCaseDetails, featchCaseSatateLu, assignedAdmins, casesTemplate, deleteCaseAssigners, saveTemplate, deleteCaseTemplate, getCasesTemplate, getStateChangeLu, updateStateChange, getDocumentReplies, casesModules,
  programsData, getGridMetaData, gridSaveLayout, gridResetLayout,
  getCardBalances, getMerchantBalances, getAddressTypes, saveRechargeEnergy, getPrograms,
  getAvailableCredits, getCreditsAmount, getAddress, depositSave, getUsedCredits, getLogoUrl, getTopupAddressLu, getTransactionsAddressLu,paginatedApiUrl
}
export default apiCalls